import styled, { Box, css, th } from '@xstyled/styled-components';
import { forwardRef } from 'react';
import { Checkmark } from '../Icons';
import { ErrorMessage, HideInput } from '../utils';

const CheckboxContainer = styled.labelBox`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  ${HideInput}
`;

const StyledCheckbox = styled.div`
  display: ${({ hidden }) => (hidden ? 'none' : 'inline-flex')};
  justify-content: center;
  align-items: center;
  padding: ${({ padding }) => padding ?? '0.5rem 0.6rem 0.6rem'};
  margin-right: 0.75rem;
  width: 15px;
  height: 15px;
  border: 1px solid ${th.color('purple-200')};
  border-radius: 3px;
  background-color: ${({ checked }) =>
    checked ? th.color('purple-200') : 'white'};
  outline: ${({ checked }) => checked && 'none'};
  cursor: pointer;

  svg {
    position: absolute;
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
    transform: ${({ padding }) => padding === 0 && 'scale(0.7)'};
  }
`;

const Checkbox = forwardRef((props, ref) => {
  return (
    <CheckboxContainer {...props}>
      <HiddenCheckbox
        ref={ref}
        name={props.name}
        checked={props.value}
        onChange={props.onChange}
      />
      <StyledCheckbox
        hidden={props.hideBox ? 1 : null}
        checked={props.value}
        padding={props.padding}
      >
        <Checkmark width="2" />
      </StyledCheckbox>
      {props.label}
      <Box position="absolute" top="3rem" left="2rem">
        {props.error && <ErrorMessage>{props.error.message}</ErrorMessage>}
      </Box>
    </CheckboxContainer>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
